export default __webpack_public_path__ + "static/media/sslogo.fba073e1.ico";